import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import Navigation from './Navigation';
import Item from './Item';
import Results from './Results';

const styles = (theme) => ({
	content: {
		position: 'relative',
	}
});

class ExerciseInterface extends Component {
	renderItems() {
		return this.props.items.map((item, i) => {
			const { _, itemIndex } = item;
			return (
				<Item
					key={itemIndex}
					index={i}
					text={_}
				/>
			);
		});
	}

	renderContent() {
		const { classes, resultsVisible } = this.props;

		return (
			<div>
				<div style={{ display: resultsVisible ? 'none' : 'block' }}>
					<div className={classes.content}>
						{this.renderItems()}
					</div>
				</div>
				{resultsVisible && <Results />}
			</div>
		);
	}

	render() {
		return (
			<div>
				{this.renderContent()}
				<Navigation />
			</div>
		);
	}
}

ExerciseInterface.propTypes = {
	classes: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	resultsVisible: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ exercise: { items, resultsVisible } }) => ({
	items,
	resultsVisible
});

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(ExerciseInterface);
